new Swiper(".tips__mobile .swiper", {
    direction: "horizontal",
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: true,
    freeMode: false,
    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
    pagination: {
        el: '.tips__mobile .swiper-pagination',
        clickable: true  
    },
    breakpoints: {
        200: { slidesPerView: 1},
        330: {
                slidesPerView: 2.0,
                spaceBetween: 1,
            },
        900: {slidesPerView: 4,}
    }
});